var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model.lazy",
          value: _vm.valueModel,
          expression: "valueModel",
          modifiers: { lazy: true },
        },
      ],
      ref: "inputRef",
      class: { "select-text-gray": !_vm.hasEmptyValue },
      attrs: {
        id: _vm.id,
        name: _vm.id || _vm.name,
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        readonly: _vm.readonly,
        "data-lpignore": _vm.browserAutocomplete ? null : true,
        autocomplete: _vm.browserAutocomplete ? null : "off",
      },
      on: {
        focus: _vm.handleBaseFocus,
        blur: _vm.handleBaseBlur,
        change: [
          function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.valueModel = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
          _vm.handleBaseChange,
        ],
        input: _vm.handleBaseInput,
      },
    },
    [
      _vm.allowEmpty
        ? _c(
            "option",
            {
              staticClass: "select-text-gray",
              attrs: { value: "" },
              domProps: { selected: !_vm.hasEmptyValue || null },
            },
            [_vm._v("\n    " + _vm._s(_vm.placeholder) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function (option) {
        return _c(
          "option",
          {
            key: option.id || option.value,
            class: option.disabled ? "select-text-gray bg-grey" : "",
            attrs: { disabled: option.disabled },
            domProps: {
              value: option.value,
              selected: _vm.isOptionSelected(option),
            },
          },
          [_vm._v("\n    " + _vm._s(option.label) + "\n  ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }